<template>
  <div id="landscape-wrapper" :class="{ 'active': handleScrollPage }">
    <div class="landscape-box">
      <Asset name="landscape.svg"
        alt="Rotação da tela"
        title="Rotação da tela"
        class="logo"
      />
      <p>Para prosseguir coloque seu celular na <b>posição vertical</b></p>
    </div>
  </div>
</template>

<script>
import Asset from '@/components/common/Asset.vue';

export default {
  name: 'landscape-card',
  components: { Asset },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    handleScrollPage() {
      if (this.active) document.body.style.overflow = 'hidden';
      else document.body.style.overflow = 'visible';
      return true;
    },
  },
};
</script>
617 -577
<style lang="scss" scoped>
  #landscape-wrapper {
    position: absolute;
    top: 0;
    z-index: 999;

    display: flex;
    justify-content: center;
    align-items: center;

    height: 100vh;
    width: 100vw;

    background: rgba(69, 79, 91, 0.9);
    overflow: hidden;
  }

  .landscape-box {
    display: flex;
    flex-direction: column;
    background: #fff;
    box-shadow: 0px 4px 36px rgba(0, 0, 0, 0.25), 0px 4px 8px rgba(0, 0, 0, 0.25);
    border-radius: 16px;
    margin: 0 57px;

    img {
      margin-top: 36px;
    }

    p {
      @extend .lead;
      color: var(--gray-600);
      text-align: center;
      line-height: 26px;

      padding: 20px 20px 20px 24px;
    }
  }
</style>
